var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCallerIDiOs = function SvgCallerIDiOs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 168,
    height: 144,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "CallerIDiOS_svg__a",
    width: 122,
    height: 98,
    x: 23,
    y: 23,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M144.423 23.435H23.858v97.412h120.565z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#CallerIDiOS_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00D639",
    d: "m75.585 80.89 16.532-2.434-1.741-46.085-14.964 2.435-7.657 33.738z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C6C6C6",
    d: "M81.559 33.78c-6.098-6.373-14.69-10.345-24.21-10.345-18.496 0-33.49 14.985-33.49 33.468s14.994 33.469 33.49 33.469c9.52 0 18.112-3.971 24.21-10.345-5.748-6.009-9.28-14.154-9.28-23.124 0-8.968 3.532-17.113 9.28-23.123"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#919191",
    d: "M105.769 23.435c-9.52 0-18.113 3.972-24.21 10.345 5.748 6.009 9.278 14.154 9.278 23.123s-3.531 17.114-9.278 23.124c6.097 6.374 14.69 10.345 24.21 10.345 18.496 0 33.49-14.985 33.49-33.469 0-18.483-14.994-33.468-33.49-33.468"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4E4E4E",
    d: "M73.487 107.259a.517.517 0 0 1-.283-.951l5.468-3.556a.518.518 0 0 1 .565.867l-5.468 3.556a.5.5 0 0 1-.282.084M61.829 120.125h-6.524a.516.516 0 1 1 0-1.034h6.524a.516.516 0 1 1 0 1.034"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B26E3D",
    d: "M49.595 57.005a1.756 1.756 0 0 0-3.514 0v3.898a1.756 1.756 0 0 0 3.514 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#919191",
    d: "m28.029 72.764 2.335-10.708 8.425-.134.21 13.493c-.075 3.86-4.51 5.714-8.05 4.167-2.622-1.146-3.64-4.189-2.92-6.818"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B26E3D",
    d: "M32.92 55.291a2.04 2.04 0 1 0 .002-4.078 2.04 2.04 0 0 0-.001 4.078"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4E4E4E",
    d: "M56.126 120.176a4.02 4.02 0 0 1-4.005-3.697l-2.14-26.638-17.15-4.742a4.02 4.02 0 0 1-2.508-2.04l-.28-.546a4.02 4.02 0 0 1 3.776-5.848l22.698 1.107c1.219.06 2.345.669 3.06 1.656l15.848 21.86a4.02 4.02 0 0 1-.898 5.614 4.025 4.025 0 0 1-5.617-.897L58.16 91.173l1.98 24.662a4.02 4.02 0 0 1-4.014 4.341"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B26E3D",
    d: "M43.354 82.152a1.757 1.757 0 0 0-.662 3.449l1.476.283a1.757 1.757 0 1 0 .662-3.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#919191",
    d: "M39.767 86.242a3.3 3.3 0 0 1-.736-.083c-.986-.222-1.907-.404-2.799-.58-1.933-.381-3.601-.71-5.095-1.296-2.032-.796-3.479-1.99-4.423-3.65-2.25-3.954-2.312-8.61-1.969-11.82.4-3.73 1.513-7.158 2.904-8.947 1.063-1.366 2.715-2.267 4.53-2.471 1.583-.177 4.034.075 6.727 2.282 1.698 1.39 2.732 3.67 3.826 6.082.553 1.22 1.125 2.48 1.717 3.44l.099.156c.1-.732.183-1.74.2-3.101a47 47 0 0 0-.142-4.183 3.327 3.327 0 0 1 3.025-3.603 3.33 3.33 0 0 1 3.607 3.02c.011.127.271 3.13.128 6.244-.094 2-.327 3.598-.714 4.885-.299.992-.687 1.798-1.19 2.463-1.03 1.364-2.286 1.802-3.157 1.93-1.78.26-4.388-.074-6.722-3.143-1.198-1.576-2.07-3.5-2.915-5.36-.552-1.217-1.477-3.253-1.985-3.685-1.013-.83-1.645-.855-1.826-.804-.334.516-1.173 2.501-1.494 5.52-.335 3.155.068 5.927 1.138 7.807.438.769 2.193 1.15 5.022 1.708.89.176 1.9.375 2.974.618a3.326 3.326 0 0 1-.73 6.572"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4E4E4E",
    d: "M104.65 120.72h-6.524a.832.832 0 1 1 0-1.663h6.524a.832.832 0 1 1 0 1.663M117.001 120.43h-6.524a.83.83 0 1 1 0-1.663h6.524a.831.831 0 1 1 0 1.663"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C6C6C6",
    d: "M139.967 87.407a3.33 3.33 0 0 1-3.151-2.255 653 653 0 0 1-5.762-17.668c-.772-2.474-1.392-4.464-1.705-5.095-.411-.302-.946-.485-2.122.48-.454.371-.997.858-1.57 1.374-3.08 2.766-7.734 6.948-13.484 6.662-2.666-.132-7.909-1.83-8.934-2.168a3.327 3.327 0 1 1 2.093-6.317c2.191.725 5.865 1.775 7.169 1.84 3.008.145 6.302-2.808 8.705-4.966.632-.567 1.228-1.102 1.799-1.57 3.485-2.856 7.498-2.985 10.733-.346 1.522 1.242 1.977 2.7 3.671 8.127 1.114 3.568 2.796 8.961 5.708 17.504a3.327 3.327 0 0 1-3.151 4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E84D4F",
    d: "M96.816 58.222a1.755 1.755 0 1 0-2.118 2.803l7.558 5.703a1.758 1.758 0 0 0 2.118-2.802zM142.164 85.768a1.757 1.757 0 0 0-3.417.818l2.208 9.204a1.757 1.757 0 0 0 3.417-.818z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C6C6C6",
    d: "m134.572 69.661-2.335-10.708-8.425-.134.249 12.804c.076 3.86 4.051 6.403 7.59 4.856 2.623-1.146 4.255-.518 2.92-6.818z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E84D4F",
    d: "M129.607 53.563a2.13 2.13 0 1 0 .002-4.26 2.13 2.13 0 0 0-.002 4.26"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#454545",
    d: "M131.73 51.254a2.13 2.13 0 0 0-2.821-1.83c.058.243.139.525.253.852.47 1.351 1.379 2.05 2.232 2.315.248-.383.378-.846.336-1.336M132.09 49.9a.936.936 0 1 0-.158-1.866.936.936 0 0 0 .158 1.865"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4E4E4E",
    d: "M103.473 120.847q-.115 0-.23-.006a4.167 4.167 0 0 1-3.937-4.387l1.698-31.196a8.8 8.8 0 0 1 7.871-8.298l16.168-1.75.125-.011 6.117-.477a4.168 4.168 0 0 1 1.736 8.076l-15.555 5.597 2.809 27.685a4.17 4.17 0 0 1-3.728 4.566 4.17 4.17 0 0 1-4.569-3.726l-2.828-27.871-1.517 27.858a4.17 4.17 0 0 1-4.16 3.941z"
  }))));
};
export default SvgCallerIDiOs;